import {
  CognitoUserPool,
  CognitoUser,
  AuthenticationDetails,
  CognitoUserAttribute,
} from 'amazon-cognito-identity-js';
import {
  Config,
  CognitoIdentityCredentials,
} from 'aws-sdk';

const _config = {
  Region: 'ap-northeast-1',
  UserPoolId: 'ap-northeast-1_38l0IqfGy',
  ClientId: '14pj56sf6ti4r34knasuitdgt',
  IdentityPoolId: 'ap-northeast-1:0a16c940-b5d9-45af-8a1c-2b051fa0e3d2',
};

export class Cognito {
  configure (config) {
    if (config.userPool) {
      this.userPool = config.userPool;
    } else {
      this.userPool = new CognitoUserPool({
        UserPoolId: config.UserPoolId,
        ClientId: config.ClientId,
      });
    }

    Config.region = config.region;
    Config.credentials = new CognitoIdentityCredentials({
      IdentityPoolId: config.IdentityPoolId,
    });
    this.options = config;
    this.currentUser = false;
  }

  static install = (Vue, options) => {
    Object.defineProperty(Vue.prototype, '$cognito', {
      get () { return this.$root._cognito; }
    });

    Vue.mixin({
      beforeCreate () {
        if (this.$options.cognito) {
          this._cognito = this.$options.cognito;
          this._cognito.configure(options);
        }
      }
    });
  }

  signin (username, password) {
    const cognitoUser = new CognitoUser({ Username: username, Pool: this.userPool });
    const authenticationDetails = new AuthenticationDetails({ Username: username, Password: password });

    return new Promise((resolve, reject) => {
      cognitoUser.authenticateUser(authenticationDetails, {
        onSuccess(result) {
          resolve(result);
        },
        onFailure(err) {
          reject(err);
        },
      });
    });
  }

  signout () {
    if (this.userPool.getCurrentUser()) {
      this.userPool.getCurrentUser().signOut();
    }
  }

  isAuthenticated () {
    this.currentUser = this.userPool.getCurrentUser();

    return new Promise((resolve, reject) => {
      if (this.currentUser == null) reject(this.currentUser);

      this.currentUser.getSession((err, session) => {
        if (err) return reject(err);
        if (!session.isValid()) return reject(session);

        resolve(session)
      });
    });
  }

  getAttribute () {
    return new Promise((resolve, reject) => {
      this.currentUser.getUserAttributes((err, result) => {
        err ? reject(err) : resolve(result);
      });
    });
  }
}


import Vue from 'vue';
Vue.use(Cognito, _config);

export default new Cognito();



// WEBPACK FOOTER //
// ./src/cognito.js